<div class="ltms-date-time-picker" #ltmsdatetimepicker>
    <div class="datetime-container">
        <button class="datetime-picker-button" [class.active]="isPickerOpen" (click)="toggleDatePicker($event)" [disabled]="readOnly">
            <img *ngIf="type == 'time' || type == 'datetime'" src="assets/images/clock.svg"/>
            <img *ngIf="type == 'date'" src="assets/images/calendar.svg"/>

            <span [class.not-selected]="value == ''"> {{(value != '')?value:placeholder}}</span>
            
        </button>
        <div class="datetime-picker-modal" [class.show-date]="type == 'date'" [class.show-time]="type == 'time'" [class.show]="isPickerOpen">
            <div class="datetime-picker-modal-body">
                <div class="datepicker-modal">
                    <table *ngIf="!isMonthYearSelectorOpen">
                        <thead>
                            <tr>
                                <th>
                                    <button [class.active]="isButtonActive('calendar','previous')" (click)="changeDatesRange($event,false)">
                                        <img src="assets/images/angle-left.svg" />
                                    </button>
                                </th>
                                <th colspan="5" style="cursor: pointer;" (click)="getMonthAndYearList($event)">
                                    {{currentMonthDetail.monthName}} {{currentMonthDetail.year}}
                                </th>
                                <th>
                                    <button [class.active]="isButtonActive('calendar','next')"  (click)="changeDatesRange($event,true)">
                                        <img src="assets/images/angle-right.svg" />
                                    </button>
                                </th>
                            </tr>
                            <tr>
                                <th *ngFor="let day of dayShortNames">{{day}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let week of currentMonthDetail.days">
                                <td *ngFor="let day of week"
                                    [id]="'date_'+day.date+'-'+day.month+'-'+day.year"
                                     (click)="selectDate(day)" [ngClass]="{
                                'selected-date':( selectedDate.date == day.date && selectedDate.month == day.month && selectedDate.year == day.year ),
                                'disabled':day.disabled,
                                'hide':!day.enabled,
                             }">
                                    {{day.date}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="year-month-selector" *ngIf="isMonthYearSelectorOpen">
                        <div class="year-month-selector-header" [class.month-selector]="isYearSelected" [class.year-selector]="!isYearSelected">
                            <button class="year-month-selector-button" (click)="changeYearList($event,false)" [disabled]="!isButtonActive('yearmonth','previous',monthYearList[0] )">
                                <img src="assets/images/angle-left.svg" />
                            </button>
                            <div class="year-month-selector-header-text" (click)="closeMonthYearSelector($event)"> {{selectedYearMonth.monthName}} {{selectedYearMonth.year}} </div>
                            <button class="year-month-selector-button" (click)="changeYearList($event,true)" [disabled]="!isButtonActive('yearmonth','next',monthYearList[monthYearList.length - 1])">
                                <img src="assets/images/angle-right.svg" />
                            </button>
                        </div>
                        <div class="year-month-list" (click)="selectMonthAndYear($event,item,i)" [class.disabled]="item.disabled" *ngFor="let item of monthYearList;let i = index">
                            {{item.name}}
                        </div>
                    </div>
                </div>
                <div class="timepicker-modal">
                    <div id="hours-selector" class="hours-selector">
                        <div *ngFor="let hour of hours" [id]="hour.text" (click)="setTime('hour',hour.value)" class="hour-option"
                            [class.active]="hour.value == selectedTime.hour">
                            {{hour.text}}
                        </div>
                    </div>
                    <div id="minutes-selector" class="minutes-selector">
                        <div *ngFor="let minute of minutes" [id]="minute.text" class="minute-option" (click)="setTime('minute',minute.value)"
                            [class.active]="minute.value == selectedTime.minute">
                            {{minute.text}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="datetime-picker-modal-footer">
                <div class="left-panel">
                    <button (click)="resetDateTime()">Reset</button>
                </div>
                <div class="right-panel">
                    <button (click)="closeDatePicker()">Cancel</button>
                    <button (click)="applyDateTime()" class="apply-button">Save</button>
                </div>
            </div>
        </div>
    </div>
</div>